import { render, staticRenderFns } from "./PrivilegeModal.vue?vue&type=template&id=de1bc1dc&scoped=true&"
import script from "./PrivilegeModal.vue?vue&type=script&lang=js&"
export * from "./PrivilegeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1bc1dc",
  null
  
)

export default component.exports